import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
var FontDescription = /** @class */ (function (_super) {
    __extends(FontDescription, _super);
    function FontDescription(fontName, fontWeight, fontPosture, fontLookup, renderingMode, cffHinting) {
        if (fontName === void 0) { fontName = '_serif'; }
        if (fontWeight === void 0) { fontWeight = 'normal'; }
        if (fontPosture === void 0) { fontPosture = 'normal'; }
        if (fontLookup === void 0) { fontLookup = 'device'; }
        if (renderingMode === void 0) { renderingMode = 'cff'; }
        if (cffHinting === void 0) { cffHinting = 'horizontalStem'; }
        var _this = _super.call(this) || this;
        _this._fontName = axCoerceString(fontName);
        _this._fontWeight = axCoerceString(fontWeight);
        _this._fontPosture = axCoerceString(fontPosture);
        _this._fontLookup = axCoerceString(fontLookup);
        _this._renderingMode = axCoerceString(renderingMode);
        _this._cffHinting = axCoerceString(cffHinting);
        return _this;
    }
    // AS -> JS Bindings
    FontDescription.isFontCompatible = function (fontName, fontWeight, fontPosture) {
        fontName = axCoerceString(fontName);
        fontWeight = axCoerceString(fontWeight);
        fontPosture = axCoerceString(fontPosture);
        console.warn('[FontDescription] - isFontCompatible not implemented');
        return null;
    };
    FontDescription.isDeviceFontCompatible = function (fontName, fontWeight, fontPosture) {
        fontName = axCoerceString(fontName);
        fontWeight = axCoerceString(fontWeight);
        fontPosture = axCoerceString(fontPosture);
        console.warn('[FontDescription] - isDeviceFontCompatible not implemented');
        return null;
    };
    Object.defineProperty(FontDescription.prototype, "renderingMode", {
        get: function () {
            return this._renderingMode;
        },
        set: function (value) {
            this._renderingMode = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontDescription.prototype, "fontLookup", {
        get: function () {
            return this._fontLookup;
        },
        set: function (value) {
            this._fontLookup = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontDescription.prototype, "fontName", {
        get: function () {
            return this._fontName;
        },
        set: function (value) {
            this._fontName = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontDescription.prototype, "fontPosture", {
        get: function () {
            return this._fontPosture;
        },
        set: function (value) {
            this._fontPosture = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontDescription.prototype, "fontWeight", {
        get: function () {
            return this._fontWeight;
        },
        set: function (value) {
            this._fontWeight = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontDescription.prototype, "cffHinting", {
        get: function () {
            return this._cffHinting;
        },
        set: function (value) {
            this._cffHinting = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontDescription.prototype, "locked", {
        get: function () {
            console.log('get FontDescription locked', this._locked);
            return this._locked;
        },
        set: function (value) {
            console.log('set FontDescription locked', value);
            this._locked = value;
        },
        enumerable: true,
        configurable: true
    });
    FontDescription.forceNativeConstructor = true;
    FontDescription.forceNativeMethods = true;
    return FontDescription;
}(ASObject));
export { FontDescription };
